import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import SocketContext from "../../context/SocketContext";

const Input = ({ message, setMessage, textRef, socket }) => {
	const { activeConversation } = useSelector((state) => state.chat);

	const [typing, setTyping] = useState(false);
	const typingTimeoutRef = useRef(null);

	const onChangeHandler = (e) => {
		setMessage(e.target.value);

		if (!typing) {
			setTyping(true);
			socket.emit("typing", activeConversation._id);
		}

		// Clear previous timeout to prevent multiple simultaneous timeouts
		if (typingTimeoutRef.current) {
			clearTimeout(typingTimeoutRef.current);
		}

		// Set new timeout - will trigger if user stops typing for 1 second
		typingTimeoutRef.current = setTimeout(() => {
			socket.emit("stop typing", activeConversation._id);
			setTyping(false);
		}, 1000);
	};

	// Cleanup on unmount or conversation change
	useEffect(() => {
		return () => {
			if (typingTimeoutRef.current) {
				clearTimeout(typingTimeoutRef.current);
			}
			if (typing && activeConversation?._id) {
				socket.emit("stop typing", activeConversation._id);
			}
		};
	}, [socket, activeConversation, typing]);

	return (
		<>
			<div className="inputMessage">
				<input
					type="text"
					className="form-control"
					placeholder="Type a message"
					value={message}
					onChange={onChangeHandler}
					ref={textRef}
				/>
			</div>
		</>
	)
}

const InputWithSocket = (props) => (
	<SocketContext.Consumer>
		{(socket) => <Input {...props} socket={socket} />}
	</SocketContext.Consumer>
);
export default InputWithSocket;